import { ChevronLeftBlueImage } from '../../../assets/images';
import { ImageAlignment } from '../../../models';
import { StackedRow } from '../../containers';
import { ImageTextLink } from '../../links';
import { ProgressStep } from '../progressStep';
import { StepState } from '../step/stepState';
import css from './HorizontalProgressIndicator.module.css';
import { Step } from './step';

export interface HorizontalProgressIndicatorProps {
  steps: ProgressStep[];
  activeStepIndex: number;
  percentComplete: number;
  onCompletedStepClicked?: (stepIndex: number) => void;
  onBackClicked?: () => void;
}

const HorizontalProgressIndicator: React.FC<
  HorizontalProgressIndicatorProps
> = (props: HorizontalProgressIndicatorProps) => {
  const { steps = [], activeStepIndex = 0 } = props;

  const onCompletedStepClicked = (stepIndex: number) => {
    props.onCompletedStepClicked && props.onCompletedStepClicked(stepIndex);
  };

  const onBackClicked = () => {
    props.onBackClicked && props.onBackClicked();
  };

  return (
    <StackedRow>
      <div className={css.backButtonContainer}>
          {activeStepIndex > 0 ? (
            <ImageTextLink
              imageSource={ChevronLeftBlueImage}
              caption="Back"
              onClick={onBackClicked}
              imageAlignment={ImageAlignment.Left}
            />
          ) : null}
        </div>
      <div className={css.progressSteps}>
        <div
          className={css.stepsContainer}
          style={
            {
              '--percentComplete': `${props.percentComplete}%`,
            } as React.CSSProperties
          }
        >
          {steps.map((step, index) => {
            let stepState = StepState.Incomplete;
            if (activeStepIndex === index) {
              stepState = StepState.Active;
            } else if (activeStepIndex > index) {
              stepState = StepState.Complete;
            }

            return (
              <Step
                key={index}
                step={step}
                stepState={stepState}
                onCompletedStepClicked={() => onCompletedStepClicked(index)}
              />
            );
          })}
        </div>
      </div>
    </StackedRow>
  );
};

export default HorizontalProgressIndicator;
